import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import _ from 'lodash';

import AccountDetail from '../components/signup/AccountDetail';
import BillingAddress from '../components/signup/BillingAddress';
import ShippingAddress from '../components/signup/ShippingAddress';
import ErrorsList from '../components/signup/ErrorsList';
import SubmissionConfirmation from '../components/SubmissionConfirmation';

import { createAddress, createUser, createCompany } from '../actions/auth';
import { updateActivePage } from '../actions/header';

const SignupContainer = ({ dispatch }) => {
  const { register, watch, errors, handleSubmit, setError } = useForm();
  const [showBillingAddress, setShowBillingAddrress] = useState(true);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    dispatch(updateActivePage(0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (data) => {
    if (data.billing_is_shipping) {
      data.billing_street = data.shipping_street;
      data.billing_city = data.shipping_city;
      data.billing_fax_number = data.shipping_fax_number;
      data.billing_phone_number = data.shipping_phone_number;
      data.billing_postal_code = data.shipping_postal_code;
      data.billing_province = data.shipping_province;
    }
    setLoading(true);

    try {
      const address = await createAddress(data);
      const company = await createCompany(data);
      await createUser(data, address, company);
      setSubmitted(true);
    } catch (error) {
      if (error.message === "Auth.form.error.email.taken") {
        setError("email", { type: "manual", message: "Email already taken" });
      } else {
        setError("form", { type: "manual", message: "Registration could not be completed. Please try again." });
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="ui centered middle aligned grid container">
      <div className={"ui inverted dimmer" + (loading ? " active" : "")}>
        <div className="ui text loader">Loading</div>
      </div>
      <div className="row">
        <div className="column">
          {submitted ? (
            <SubmissionConfirmation type="registration" />
          ) : <form onSubmit={handleSubmit(onSubmit)} className="ui large form segment">

            <AccountDetail register={register} watch={watch} errors={errors} />

            <ShippingAddress register={register} errors={errors} />

            <div className="field">
              <div className="fields">
                <div className="twelve wide field">
                  <div className="ui checkbox">
                    <input name="billing_is_shipping" type="checkbox" ref={register} onChange={(e) => {setShowBillingAddrress(!e.target.checked)}} />
                    <label>Billing address is same as shipping address</label>
                  </div>
                </div>
              </div>
            </div>

            { showBillingAddress ? <BillingAddress register={register} errors={errors} /> : null }

            <button disabled={loading} type="submit" className="ui large black submit button">Complete Registration</button>
          </form>}

          {submitted || _.isEmpty(errors) ? null : <ErrorsList errors={errors} customErrors />}

          <div className="ui message">
            Already have an account? <a href="/login">Login</a>
          </div>
        </div>
      </div>
      <div className="ui hidden divider" />
    </div>
  )
};

export default connect()(SignupContainer);
